import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Atelier } from '@/components/landing/atelier/atelier'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <Atelier />
        </>
    )
}

export default Home
